// Simple i18n dictionary (DE default, EN available)
export const dict = {
  de: {
    app_name: "Rankly",
    tagline: "Multi-Shop SEO & Sichtbarkeits-Kommandozentrale",
    login_title: "Bei Rankly anmelden",
    login_subtitle:
      "Ranking-Überwachung, Site-Audits und Sichtbarkeit für all deine Shops – an einem Ort.",
    login_with_google: "Mit Google anmelden",
    login_tab_password: "E-Mail & Passwort",
    login_email_label: "E-Mail",
    login_password_label: "Passwort",
    login_submit: "Anmelden",
    login_google_hint:
      "Nur autorisierte Google-Konten können sich anmelden. Andere erhalten „Zugriff verweigert“.",
    login_error_missing_fields: "Bitte E-Mail und Passwort eingeben.",
    login_error_generic: "Anmeldung fehlgeschlagen. Bitte erneut versuchen.",
    login_error_forbidden_title: "Zugriff verweigert",
    login_error_forbidden_desc:
      "Diese Google-Adresse ist nicht für Rankly freigeschaltet. Bitte melde dich mit einer autorisierten E-Mail an.",
    logout: "Abmelden",
    nav_dashboard: "Dashboard",
    nav_keywords: "Keywords",
    nav_audit: "Site Audit",
    nav_settings: "Einstellungen",
    nav_competitors: "Wettbewerber",
    nav_cro: "CRO Studio",
    nav_reports: "Reports",
    nav_search_console: "Search Console",
    coming_soon: "Bald verfügbar",
    shop: "Shop",
    all_shops: "Alle Shops",
    kpi_keywords_tracked: "Keywords getrackt",
    kpi_avg_position: "Ø Position",
    kpi_visibility: "Sichtbarkeitsindex",
    kpi_traffic: "Organischer Traffic (est.)",
    kpi_revenue: "Umsatz-Potenzial",
    top_3: "Top 3",
    top_10: "Top 10",
    top_100: "Top 100",
    positions_up: "Positionen ↑",
    positions_down: "Positionen ↓",
    visibility_trend: "Sichtbarkeits-Verlauf (30 T)",
    position_distribution: "Positions-Verteilung",
    intent: "Intent",
    keyword: "Keyword",
    position: "Pos.",
    change: "Δ",
    search_volume: "Volumen",
    difficulty: "Schwierigkeit",
    cpc: "CPC",
    url: "URL",
    trend_30d: "Trend 30 T",
    search_keywords: "Keyword filtern…",
    refresh_ranks: "Rankings aktualisieren",
    refreshing: "Aktualisiere…",
    audit_health: "SEO-Gesundheit",
    audit_crawlability: "Crawlability",
    audit_performance: "Performance",
    audit_onpage: "On-Page",
    audit_links: "Interne Links",
    core_web_vitals: "Core Web Vitals",
    crawled_pages: "Analysierte Seiten",
    errors: "Fehler",
    warnings: "Warnungen",
    notices: "Hinweise",
    audit_issues: "Gefundene Probleme",
    severity: "Schwere",
    category: "Kategorie",
    count: "Anzahl",
    updated_at: "Aktualisiert",
    settings_language: "Sprache",
    settings_theme: "Design",
    settings_account: "Konto",
    settings_shops: "Verbundene Shops",
    settings_integrations: "Integrationen",
    settings_users: "Nutzerverwaltung",
    settings_docs: "Handbücher & Downloads",
    docs_description:
      "Alle Rankly-Handbücher als PDF – jederzeit lokal auf dem Server verfügbar.",
    users_admin_only: "Nur Admins können Nutzer verwalten.",
    users_description: "Lege Nutzer für Rankly an und verwalte Rollen & Passwörter.",
    users_load_error: "Nutzer konnten nicht geladen werden.",
    users_add: "Nutzer hinzufügen",
    users_add_desc: "Neuer Nutzer erhält sofort Zugriff über E-Mail & Passwort.",
    users_name: "Name",
    users_role: "Rolle",
    users_create: "Anlegen",
    users_created_toast: "Nutzer angelegt.",
    users_create_error: "Nutzer konnte nicht angelegt werden.",
    users_missing_fields: "Bitte alle Pflichtfelder ausfüllen.",
    users_password_too_short: "Passwort muss mindestens 8 Zeichen haben.",
    users_password_hint: "min. 8 Zeichen",
    users_change_password: "Passwort ändern",
    users_new_password: "Neues Passwort",
    users_save: "Speichern",
    users_pw_changed_toast: "Passwort geändert.",
    users_pw_error: "Passwort konnte nicht geändert werden.",
    users_delete_title: "Nutzer löschen?",
    users_delete_desc: "„{email}“ kann sich danach nicht mehr anmelden.",
    users_delete_confirm: "Löschen",
    users_deleted_toast: "Nutzer gelöscht.",
    users_delete_error: "Nutzer konnte nicht gelöscht werden.",
    cancel: "Abbrechen",
    integration_configured: "Konfiguriert",
    integration_missing: "Nicht konfiguriert",
    integration_dataforseo_hint: "DATAFORSEO_LOGIN + DATAFORSEO_PASSWORD in backend/.env",
    integration_resend_hint: "RESEND_API_KEY in backend/.env",
    integration_llm_hint: "EMERGENT_LLM_KEY in backend/.env",
    good: "Gut",
    needs_improvement: "Verbesserungswürdig",
    poor: "Schlecht",
    critical: "Kritisch",
    warning: "Warnung",
    notice: "Hinweis",
    high: "Hoch",
    medium: "Mittel",
    low: "Niedrig",
    informational: "informativ",
    commercial: "kommerziell",
    transactional: "transaktional",
    navigational: "navigational",
    local: "lokal",
    dark: "Dunkel",
    light: "Hell",
    system: "System",
    checking: "Prüfe Sitzung…",
    hero_bullet_1: "Rank-Tracking + Wettbewerber-Vergleich für 4 Shops",
    hero_bullet_2: "AI-gestütztes CRO-Studio (Claude Sonnet 4.5)",
    hero_bullet_3: "Automatischer Wochen-Digest (PDF + E-Mail)",
    // Competitors
    competitors_title: "Wettbewerber-Sichtbarkeit",
    add_competitor: "Wettbewerber hinzufügen",
    add_competitor_placeholder: "domain.com",
    domain: "Domain",
    visibility: "Sichtbarkeit",
    shared_keywords: "Geteilte Keywords",
    trend_30d_short: "30 T Δ",
    your_shop: "Dein Shop",
    // CRO
    cro_title: "CRO Studio",
    cro_subtitle: "Funnel-Analyse & AI-Empfehlungen für mehr Umsatz",
    cro_status_todo: "Offen",
    cro_status_progress: "In Arbeit",
    cro_status_done: "Erledigt",
    cro_status_error: "Status konnte nicht gespeichert werden",
    cro_generate_plan: "Umsetzungsplan generieren",
    cro_plan_regenerate: "Neu generieren",
    cro_plan_generating: "KI erstellt deinen Umsetzungsplan…",
    cro_plan_generating_short: "Generiere…",
    cro_plan_generating_long:
      "Claude erstellt gerade einen konkreten Umsetzungsplan mit Copy-Paste-Vorlagen. Das dauert ca. 30–60 Sekunden.",
    cro_plan_error: "Umsetzungsplan konnte nicht generiert werden",
    cro_plan_title: "Konkreter Umsetzungsplan",
    cro_plan_none: "Noch kein Plan generiert.",
    cro_plan_copied: "In die Zwischenablage kopiert",
    cro_plan_copy_all: "Alles kopieren",
    cro_plan_mark_done: "Als erledigt markieren",
    cro_view_plan: "Plan ansehen",
    cro_copy_emergent_prompt: "Emergent-Prompt kopieren",
    cro_copy_emergent_prompt_short: "Für Emergent kopieren",
    cro_emergent_prompt_copied: "Emergent-Prompt in die Zwischenablage kopiert. Jetzt in Emergent einfügen.",
    cro_bulk_button: "Alle Pläne generieren",
    cro_bulk_running: "läuft…",
    cro_bulk_started: "KI erstellt Pläne für {n} Empfehlung(en). Das dauert 1–2 Minuten.",
    cro_bulk_done: "{n} Pläne fertig erstellt.",
    cro_bulk_partial: "{ok} erfolgreich, {fail} fehlgeschlagen.",
    cro_bulk_none_pending: "Alle Empfehlungen haben bereits einen Plan.",
    alerts_title: "Underperformer-Alerts",
    alerts_critical: "kritisch",
    alerts_warning: "Warnung",
    alerts_dismiss_all: "Alle abhaken",
    alerts_dismissed_all: "{n} Alerts abgehakt.",
    revenue_impact_title: "Geschätztes Umsatz-Plus pro Jahr",
    revenue_year: "Jahr",
    revenue_month: "Monat",
    impact_title: "Wirkung seit Umsetzung",
    impact_today: "heute festgehalten",
    impact_days_ago: "seit {n} Tagen",
    impact_conversion: "Conversion Rate",
    impact_visitors: "Besucher (30 T)",
    impact_revenue: "Umsatz (Monat)",
    impact_top10: "Keywords Top-10",
    retest_button: "Alles neu prüfen",
    retest_running: "prüfe…",
    retest_hint: "Frische Live-Daten holen (Rankings + Site Audit) und Impact-Cards aktualisieren",
    retest_error: "Retest fehlgeschlagen — bitte in einer Minute erneut versuchen.",
    audit_problem: "Problem",
    audit_affected_urls: "Betroffene URLs (Beispiele)",
    audit_urls_hint: "Beispiele — Rankly zeigt hier ein Sample. Für die vollständigen {n} Vorkommen führt Emergent einen kompletten Crawl durch.",
    audit_how_to_fix: "So beheben",
    audit_emergent_prompt: "Emergent-Prompt (Copy-Paste)",
    audit_emergent_hint: "Kopiere den Prompt oben und füge ihn in deinem Emergent-Chat ein, um alle Vorkommen beheben zu lassen.",
    audit_open_emergent: "Emergent öffnen",
    audit_prompt_copied: "Prompt in die Zwischenablage kopiert.",
    copy: "Kopieren",
    copied: "Kopiert",
    funnel: "Funnel (30 Tage)",
    visitors: "Besucher",
    conversions: "Conversions",
    conversion_rate: "Conversion Rate",
    revenue: "Umsatz",
    avg_order_value: "Ø Bestellwert",
    biggest_drop: "Größter Absprung",
    generate_recommendations: "AI-Empfehlungen generieren",
    generating: "AI analysiert…",
    ai_recommendations: "Empfehlungen für mehr Umsatz",
    expected_uplift: "Erwarteter Uplift",
    est_revenue_lift: "Zusätzlicher Umsatz",
    effort: "Aufwand",
    hypothesis: "Hypothese",
    experiment: "Experiment",
    problem: "Problem",
    priority: "Priorität",
    powered_by: "Powered by",
    // Reports
    reports_title: "Wochen-Digest",
    reports_subtitle: "Kompakter Report für dich und dein Team",
    revenue_this_week: "Umsatz-Estimate",
    visibility_change: "Sichtbarkeits-Δ",
    critical_issues: "Kritische Probleme",
    top_gainers: "Top Gewinner",
    top_losers: "Top Verlierer",
    keywords_gained: "Keywords gewonnen",
    keywords_lost: "Keywords verloren",
    download_pdf: "PDF herunterladen",
    send_by_email: "Per E-Mail senden",
    email_placeholder: "email@example.com",
    email_sent: "E-Mail versendet",
    email_configure_hint: "Resend-API-Key fehlt – bitte in backend/.env eintragen.",
    // Subscription
    weekly_subscription: "Automatischer Wochen-Digest",
    subscription_description:
      "Erhalte den Report jede Woche automatisch per E-Mail. Läuft im Hintergrund auf dem Server.",
    weekday: "Wochentag",
    hour_utc: "Uhrzeit (UTC)",
    enabled: "Aktiv",
    disabled: "Deaktiviert",
    save: "Speichern",
    save_and_activate: "Speichern & aktivieren",
    send_now: "Jetzt senden",
    saved: "Gespeichert",
    last_sent: "Zuletzt versendet",
    never_sent: "Noch nicht versendet",
    mon: "Montag", tue: "Dienstag", wed: "Mittwoch", thu: "Donnerstag",
    fri: "Freitag", sat: "Samstag", sun: "Sonntag",
    // Google integration
    google_integration: "Google Search Console & GA4",
    google_connected: "Verbunden",
    google_not_connected: "Nicht verbunden",
    google_connect: "Google verbinden",
    google_disconnect: "Trennen",
    google_not_configured_hint:
      "OAuth-Client fehlt. Trage GOOGLE_OAUTH_CLIENT_ID + GOOGLE_OAUTH_CLIENT_SECRET in backend/.env ein.",
    google_per_shop_hint:
      "Verbinde jedes Shop-Property einzeln, damit wir echte GSC-Clicks & GA4-Sessions ziehen können.",
    google_connected_toast: "Google-Konto verbunden",
    google_error_toast: "Google-Verbindung fehlgeschlagen",
    gsc_connect_title: "Google Search Console verbinden",
    gsc_connect_hint:
      "Verbinde dein GSC-Konto in den Einstellungen, um echte Impressionen & Clicks zu sehen.",
  },
  en: {
    app_name: "Rankly",
    tagline: "Multi-Shop SEO & Visibility Command Center",
    login_title: "Sign in to Rankly",
    login_subtitle:
      "Rank tracking, site audits, and visibility across all your shops — in one place.",
    login_with_google: "Continue with Google",
    login_tab_password: "Email & Password",
    login_email_label: "Email",
    login_password_label: "Password",
    login_submit: "Sign in",
    login_google_hint:
      "Only authorised Google accounts can sign in. Others will be rejected.",
    login_error_missing_fields: "Please enter email and password.",
    login_error_generic: "Sign-in failed. Please try again.",
    login_error_forbidden_title: "Access denied",
    login_error_forbidden_desc:
      "This Google account is not authorised for Rankly. Please sign in with an approved email.",
    logout: "Sign out",
    nav_dashboard: "Dashboard",
    nav_keywords: "Keywords",
    nav_audit: "Site Audit",
    nav_settings: "Settings",
    nav_competitors: "Competitors",
    nav_cro: "CRO Studio",
    nav_reports: "Reports",
    nav_search_console: "Search Console",
    coming_soon: "Coming soon",
    shop: "Shop",
    all_shops: "All shops",
    kpi_keywords_tracked: "Keywords tracked",
    kpi_avg_position: "Avg. position",
    kpi_visibility: "Visibility score",
    kpi_traffic: "Organic traffic (est.)",
    kpi_revenue: "Revenue potential",
    top_3: "Top 3",
    top_10: "Top 10",
    top_100: "Top 100",
    positions_up: "Positions ↑",
    positions_down: "Positions ↓",
    visibility_trend: "Visibility trend (30d)",
    position_distribution: "Position distribution",
    intent: "Intent",
    keyword: "Keyword",
    position: "Pos.",
    change: "Δ",
    search_volume: "Volume",
    difficulty: "KD",
    cpc: "CPC",
    url: "URL",
    trend_30d: "30d trend",
    search_keywords: "Filter keywords…",
    refresh_ranks: "Refresh rankings",
    refreshing: "Refreshing…",
    audit_health: "SEO health",
    audit_crawlability: "Crawlability",
    audit_performance: "Performance",
    audit_onpage: "On-page",
    audit_links: "Internal links",
    core_web_vitals: "Core Web Vitals",
    crawled_pages: "Pages crawled",
    errors: "Errors",
    warnings: "Warnings",
    notices: "Notices",
    audit_issues: "Detected issues",
    severity: "Severity",
    category: "Category",
    count: "Count",
    updated_at: "Updated",
    settings_language: "Language",
    settings_theme: "Theme",
    settings_account: "Account",
    settings_shops: "Connected shops",
    settings_integrations: "Integrations",
    settings_users: "User management",
    settings_docs: "Handbooks & Downloads",
    docs_description:
      "All Rankly handbooks as PDFs – always available locally on the server.",
    users_admin_only: "Only admins can manage users.",
    users_description: "Create Rankly users and manage roles & passwords.",
    users_load_error: "Failed to load users.",
    users_add: "Add user",
    users_add_desc: "New user gets immediate email/password access.",
    users_name: "Name",
    users_role: "Role",
    users_create: "Create",
    users_created_toast: "User created.",
    users_create_error: "Could not create user.",
    users_missing_fields: "Please fill in all required fields.",
    users_password_too_short: "Password must be at least 8 characters.",
    users_password_hint: "min. 8 characters",
    users_change_password: "Change password",
    users_new_password: "New password",
    users_save: "Save",
    users_pw_changed_toast: "Password changed.",
    users_pw_error: "Could not change password.",
    users_delete_title: "Delete user?",
    users_delete_desc: "\"{email}\" will no longer be able to sign in.",
    users_delete_confirm: "Delete",
    users_deleted_toast: "User deleted.",
    users_delete_error: "Could not delete user.",
    cancel: "Cancel",
    integration_configured: "Configured",
    integration_missing: "Not configured",
    integration_dataforseo_hint: "DATAFORSEO_LOGIN + DATAFORSEO_PASSWORD in backend/.env",
    integration_resend_hint: "RESEND_API_KEY in backend/.env",
    integration_llm_hint: "EMERGENT_LLM_KEY in backend/.env",
    good: "Good",
    needs_improvement: "Needs improvement",
    poor: "Poor",
    critical: "Critical",
    warning: "Warning",
    notice: "Notice",
    high: "High",
    medium: "Medium",
    low: "Low",
    informational: "informational",
    commercial: "commercial",
    transactional: "transactional",
    navigational: "navigational",
    local: "local",
    dark: "Dark",
    light: "Light",
    system: "System",
    checking: "Checking session…",
    hero_bullet_1: "Rank tracking + competitor comparison for 4 shops",
    hero_bullet_2: "AI-powered CRO studio (Claude Sonnet 4.5)",
    hero_bullet_3: "Automated weekly digest (PDF + email)",
    // Competitors
    competitors_title: "Competitor visibility",
    add_competitor: "Add competitor",
    add_competitor_placeholder: "domain.com",
    domain: "Domain",
    visibility: "Visibility",
    shared_keywords: "Shared keywords",
    trend_30d_short: "30d Δ",
    your_shop: "Your shop",
    // CRO
    cro_title: "CRO Studio",
    cro_subtitle: "Funnel analysis & AI recommendations to lift revenue",
    cro_status_todo: "To do",
    cro_status_progress: "In progress",
    cro_status_done: "Done",
    cro_status_error: "Could not save status",
    cro_generate_plan: "Generate action plan",
    cro_plan_regenerate: "Regenerate",
    cro_plan_generating: "AI is building your implementation plan…",
    cro_plan_generating_short: "Generating…",
    cro_plan_generating_long:
      "Claude is drafting a concrete implementation plan with ready-to-copy templates. This takes about 30–60 seconds.",
    cro_plan_error: "Could not generate the plan",
    cro_plan_title: "Concrete implementation plan",
    cro_plan_none: "No plan generated yet.",
    cro_plan_copied: "Copied to clipboard",
    cro_plan_copy_all: "Copy all",
    cro_plan_mark_done: "Mark as done",
    cro_view_plan: "View plan",
    cro_copy_emergent_prompt: "Copy Emergent prompt",
    cro_copy_emergent_prompt_short: "Copy for Emergent",
    cro_emergent_prompt_copied: "Emergent prompt copied to clipboard. Paste it into Emergent now.",
    cro_bulk_button: "Generate all plans",
    cro_bulk_running: "running…",
    cro_bulk_started: "AI is generating plans for {n} recommendation(s). Takes 1–2 minutes.",
    cro_bulk_done: "{n} plans generated.",
    cro_bulk_partial: "{ok} succeeded, {fail} failed.",
    cro_bulk_none_pending: "All recommendations already have a plan.",
    alerts_title: "Underperformer alerts",
    alerts_critical: "critical",
    alerts_warning: "warning",
    alerts_dismiss_all: "Dismiss all",
    alerts_dismissed_all: "{n} alerts dismissed.",
    revenue_impact_title: "Estimated annual revenue lift",
    revenue_year: "yr",
    revenue_month: "mo",
    impact_title: "Impact since implementation",
    impact_today: "captured today",
    impact_days_ago: "{n} days ago",
    impact_conversion: "Conversion Rate",
    impact_visitors: "Visitors (30 d)",
    impact_revenue: "Revenue (month)",
    impact_top10: "Keywords Top-10",
    retest_button: "Retest everything",
    retest_running: "checking…",
    retest_hint: "Fetch fresh live data (rankings + site audit) and refresh impact cards",
    retest_error: "Retest failed — please try again in a minute.",
    audit_problem: "Problem",
    audit_affected_urls: "Affected URLs (samples)",
    audit_urls_hint: "Samples only — Rankly shows a subset. For the full {n} occurrences Emergent will do a complete crawl.",
    audit_how_to_fix: "How to fix",
    audit_emergent_prompt: "Emergent prompt (copy-paste)",
    audit_emergent_hint: "Copy the prompt above and paste it into your Emergent chat to fix all occurrences.",
    audit_open_emergent: "Open Emergent",
    audit_prompt_copied: "Prompt copied to clipboard.",
    copy: "Copy",
    copied: "Copied",
    funnel: "Funnel (30 days)",
    visitors: "Visitors",
    conversions: "Conversions",
    conversion_rate: "Conversion rate",
    revenue: "Revenue",
    avg_order_value: "Avg. order value",
    biggest_drop: "Biggest drop",
    generate_recommendations: "Generate AI recommendations",
    generating: "AI analyzing…",
    ai_recommendations: "Recommendations to lift revenue",
    expected_uplift: "Expected uplift",
    est_revenue_lift: "Estimated revenue lift",
    effort: "Effort",
    hypothesis: "Hypothesis",
    experiment: "Experiment",
    problem: "Problem",
    priority: "Priority",
    powered_by: "Powered by",
    // Reports
    reports_title: "Weekly digest",
    reports_subtitle: "A compact report for you and your team",
    revenue_this_week: "Revenue estimate",
    visibility_change: "Visibility Δ",
    critical_issues: "Critical issues",
    top_gainers: "Top gainers",
    top_losers: "Top losers",
    keywords_gained: "Keywords gained",
    keywords_lost: "Keywords lost",
    download_pdf: "Download PDF",
    send_by_email: "Send by email",
    email_placeholder: "email@example.com",
    email_sent: "Email sent",
    email_configure_hint: "Resend API key missing — please add it to backend/.env.",
    // Subscription
    weekly_subscription: "Automated weekly digest",
    subscription_description:
      "Receive the report automatically every week via email. Runs in the background on the server.",
    weekday: "Weekday",
    hour_utc: "Hour (UTC)",
    enabled: "Active",
    disabled: "Disabled",
    save: "Save",
    save_and_activate: "Save & activate",
    send_now: "Send now",
    saved: "Saved",
    last_sent: "Last sent",
    never_sent: "Not sent yet",
    mon: "Monday", tue: "Tuesday", wed: "Wednesday", thu: "Thursday",
    fri: "Friday", sat: "Saturday", sun: "Sunday",
    // Google integration
    google_integration: "Google Search Console & GA4",
    google_connected: "Connected",
    google_not_connected: "Not connected",
    google_connect: "Connect Google",
    google_disconnect: "Disconnect",
    google_not_configured_hint:
      "OAuth client missing. Add GOOGLE_OAUTH_CLIENT_ID + GOOGLE_OAUTH_CLIENT_SECRET to backend/.env.",
    google_per_shop_hint:
      "Connect each shop's property individually so we can pull real GSC clicks & GA4 sessions.",
    google_connected_toast: "Google account connected",
    google_error_toast: "Google connection failed",
    gsc_connect_title: "Connect Google Search Console",
    gsc_connect_hint:
      "Connect your GSC account in Settings to see real impressions & clicks.",
  },
};

export const languages = [
  { code: "de", label: "Deutsch" },
  { code: "en", label: "English" },
];
